<template>
  <span
    v-if="use"
    class="jade-icon"
    :class="computedClassList"
    v-bind="$attrs"
  >
    <component :is="computedDynamicIcon" />
  </span>
</template>

<script>
import ICON_LIST from '../utils/icons.utils'
import SIZE_ENUM from '../enums/sizes.enum'
import COLOR_ENUM from '../enums/colors.enum'

export default {
  name: 'jade-icon',

  props: {
    use: {
      type: String,
      validation: icon => ICON_LIST.includes(icon)
    },
    size: {
      type: String,
      validation: size => Object.values(SIZE_ENUM).includes(size),
      default: SIZE_ENUM.MEDIUM
    },
    color: {
      type: String,
      validation: size => Object.values(COLOR_ENUM).includes(size),
      default: COLOR_ENUM.MEDIUM
    }
  },

  computed: {
    computedClassList () {
      return {
        [`is-color-${this.color}`]: this.color,
        [`is-${this.size}`]: this.size
      }
    },
    computedDynamicIcon () {
      return this.use
        ? () =>
            import(
              /* webpackChunkName: "jade-design-tokens/icons/[request]" */ '@stone-payments/jade-design-tokens/icons/' +
                this.use +
                '.svg?inline'
            )
        : ''
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/icon.css';
</style>
